<button type="button" class="console-icon-btn" (click)="copy()" [attr.aria-label]="ariaLabel">
  <ng-icon name="lucideCopy" size="16"></ng-icon>
</button>
